import { Box, Typography } from "@mui/material";
import { SxProps, Theme } from "@mui/material/styles";

// Normaliza o HTML vindo do editor (artigos legados e seções de página customizada), removendo estilos inline
const richTextSx: SxProps<Theme> = {
    // Normalização global - remove estilos inline
    '& *': {
        fontFamily: 'inherit !important',
        margin: '0 !important',
        padding: '0 !important',
    },
    '& p, & div, & span': {
        fontSize: '1.0625rem !important',
        lineHeight: '1.75 !important',
        marginBottom: '1rem !important',
        marginTop: '0 !important',
        paddingLeft: '0 !important',
        paddingRight: '0 !important',
    },
    '& p, & ul, & ol, & blockquote, & h1, & h2, & h3, & h4': {
        maxWidth: '75ch',
    },
    '& p:last-child, & div:last-child': {
        marginBottom: '0 !important',
    },
    '& strong, & b': {
        fontWeight: '600 !important',
    },
    '& em, & i': {
        fontStyle: 'italic !important',
    },
    '& img': {
        maxWidth: '100%',
        height: 'auto',
        borderRadius: 1,
        marginTop: '1.5rem !important',
        marginBottom: '1.5rem !important',
        marginLeft: '0 !important',
        marginRight: '0 !important',
    },
    '& h1': {
        fontSize: '2rem !important',
        fontWeight: '700 !important',
        marginTop: '2rem !important',
        marginBottom: '1rem !important',
        lineHeight: '1.3 !important',
    },
    '& h2': {
        fontSize: '1.75rem !important',
        fontWeight: '700 !important',
        marginTop: '2rem !important',
        marginBottom: '1rem !important',
        lineHeight: '1.3 !important',
    },
    '& h3': {
        fontSize: '1.5rem !important',
        fontWeight: '600 !important',
        marginTop: '1.75rem !important',
        marginBottom: '0.875rem !important',
        lineHeight: '1.4 !important',
    },
    '& h4': {
        fontSize: '1.25rem !important',
        fontWeight: '600 !important',
        marginTop: '1.5rem !important',
        marginBottom: '0.75rem !important',
        lineHeight: '1.4 !important',
    },
    '& h5': {
        fontSize: '1.125rem !important',
        fontWeight: '600 !important',
        marginTop: '1.5rem !important',
        marginBottom: '0.75rem !important',
        lineHeight: '1.4 !important',
    },
    '& h6': {
        fontSize: '1rem !important',
        fontWeight: '600 !important',
        marginTop: '1.5rem !important',
        marginBottom: '0.75rem !important',
        lineHeight: '1.4 !important',
    },
    '& ul, & ol': {
        marginBottom: '1rem !important',
        marginTop: '0.5rem !important',
        paddingLeft: '2rem !important',
        fontSize: '1rem !important',
    },
    '& li': {
        marginBottom: '0.5rem !important',
        marginTop: '0 !important',
        lineHeight: '1.8 !important',
        fontSize: '1rem !important',
    },
    '& blockquote': {
        borderLeft: '4px solid',
        borderColor: 'primary.main',
        paddingLeft: '1rem !important',
        paddingRight: '1rem !important',
        paddingTop: '0.5rem !important',
        paddingBottom: '0.5rem !important',
        marginTop: '1rem !important',
        marginBottom: '1rem !important',
        marginLeft: '0 !important',
        marginRight: '0 !important',
        fontStyle: 'italic',
        backgroundColor: 'grey.50',
        fontSize: '1rem !important',
    },
    '& a': {
        color: 'brand.text',
        textDecoration: 'none',
        fontSize: 'inherit !important',
        '&:hover': {
            textDecoration: 'underline',
        },
    },
    '& table': {
        width: '100%',
        borderCollapse: 'collapse',
        marginTop: '1.5rem !important',
        marginBottom: '1.5rem !important',
        marginLeft: '0 !important',
        marginRight: '0 !important',
        '& th, & td': {
            border: '1px solid',
            borderColor: 'divider',
            padding: '0.75rem !important',
            textAlign: 'left',
            fontSize: '0.95rem !important',
        },
        '& th': {
            backgroundColor: 'grey.100',
            fontWeight: '600 !important',
        },
    },
    // Primeiro elemento não tem margem superior
    '& > *:first-of-type': {
        marginTop: '0 !important',
    },
    // Último elemento não tem margem inferior
    '& > *:last-child': {
        marginBottom: '0 !important',
    },
};

export function RichTextContent({ html }: { html: string | undefined }) {
    if (!html) return null;

    return (
        <Box sx={richTextSx}>
            <Typography component="div" dangerouslySetInnerHTML={{ __html: html }} />
        </Box>
    );
}
